import React from 'react';
import { Flex, Image } from '@spothero/ui';
import { getWindow } from 'ssr-window';
import useConfig from 'hooks/use-config';
import useIsMobile from 'hooks/use-is-mobile';
const window = getWindow();
/**
 * FacilityMap component displays a static Google Map image with a marker at the facility location.
 * Uses the Google Static Maps API to generate a map image.
 */
const SpotDetailsMap = ({ spotLatitude: latitude, spotLongitude: longitude, }) => {
    const { googleMapsApiKey: apiKey } = useConfig();
    const isMobile = useIsMobile();
    if (typeof window === 'undefined' || !apiKey) {
        return null;
    }
    // Build Google Static Maps API URL
    const center = `${latitude},${longitude}`;
    const marker = `color:red|${latitude},${longitude}`;
    const searchParams = new URLSearchParams({
        center,
        zoom: isMobile ? '17' : '17',
        size: '640x640',
        scale: '2',
        markers: marker,
        key: apiKey,
    });
    const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?${searchParams.toString()}`;
    return (<Flex height={48} width="100%" overflow="hidden" alignItems="center">
            <Image src={staticMapUrl} alt="Facility location map"/>
        </Flex>);
};
export default SpotDetailsMap;
